// frontend/src/components/ContactIcons.jsx
import "./ContactIcons.css";

export default function ContactIcons({ onCtaClick }) {
  return (
    <>
      {/* Desktop floating icons */}
      <div className="contact-float desktop-only" aria-label="Contact options">
        <a
          href="https://wa.me/+918069368300"
          className="contact-float__btn contact-float__btn--wa"
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
        >
          <img src="https://microsite.thehomestore.co.in/uploads/whatsapp_icon.png" alt="WhatsApp" />
        </a>
        <button
          className="contact-float__btn contact-float__btn--phone"
          onClick={() => onCtaClick("Contact Icon")}
          aria-label="Call us"
        >
          <img src="https://microsite.thehomestore.co.in/uploads/contact_icon.webp" alt="Call" />
        </button>
      </div>

      {/* Mobile sticky bottom bar */}
      <div className="mobile-bar mobile-only" role="navigation" aria-label="Contact bar">
        <button
          className="mobile-bar__half mobile-bar__half--left"
          onClick={() => onCtaClick("Contact Icon")}
          aria-label="Instant call"
        >
          <img src="https://microsite.thehomestore.co.in/uploads/contact_icon.webp" alt="Call" />
          <span>Instant Call</span>
        </button>

        <div className="mobile-bar__sep" aria-hidden="true" />

        <a
          href="https://wa.me/+918069368300"
          className="mobile-bar__half mobile-bar__half--right"
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
        >
          <img src="https://microsite.thehomestore.co.in/uploads/whatsapp_icon.png" alt="WhatsApp" />
          <span>WhatsApp</span>
        </a>
      </div>
    </>
  );
}
